import { render, staticRenderFns } from "./polityka-prywatnosci.vue?vue&type=template&id=2cd6e667&"
import script from "./polityka-prywatnosci.vue?vue&type=script&lang=js&"
export * from "./polityka-prywatnosci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LegalDocument: require('/var/www/jaty-frontend/components/LegalDocument.vue').default})
